<template>
    <div class="tab-pane active">
        <form @submit.prevent="update()" class="p-15">
            <div class="row">
                <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['additional_info']}">
                    <label class="control-label"></label>
                    <pml-summernote v-model="record.additional_info" :value="record.additional_info" :show-deal-btn="false"></pml-summernote>
                    <span class="error" v-if="errors['additional_info']">{{ errors['additional_info'][0] }}</span>
                </div>
                <div class="col-sm-12 t_right">
                    <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { update } from 'services/quotations'
    import { mapGetters } from 'vuex'
    import { cloneDeep } from 'lodash'

    export default {
        name: 'QuotationAdditionalInfo',
        data () {
            return {
                record: {},
                errors: [],
                isSaving: false
            }
        },
        mounted () {
            this.record = cloneDeep(this.quotation)
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                return this.quotations.find((item) => item.id === parseInt(this.$route.params.quotation)) || {}
            }
        },
        methods: {
            update () {
                this.isSaving = true

                let payload = {
                    additional_info: this.record.additional_info,
                    currency_id: this.record.currency_id,
                    language: this.record.language
                }

                update(this.deal.id, this.quotation.id, payload)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/AdditionalInfo.vue